import { AlertTriangle, MousePointerClick, ShoppingBag, Wallet } from "lucide-react";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { reais } from "@/features/disparos/sms/api";

/** Pede o nome de uma rede extra ou de um influencer antes de gerar o link. */
export function ModalNovoLink({ aberto, titulo, descricao, placeholder, onFechar, onCriar }) {
  const [nome, setNome] = useState("");
  const [salvando, setSalvando] = useState(false);
  useEffect(() => { if (aberto) { setNome(""); setSalvando(false); } }, [aberto]);

  const criar = async () => {
    if (!nome.trim() || salvando) return;
    setSalvando(true);
    try { await onCriar(nome.trim()); onFechar(); }
    finally { setSalvando(false); }
  };

  return (
    <Dialog open={aberto} onOpenChange={(v) => { if (!v) onFechar(); }}>
      <DialogContent className="w-[95vw] max-w-[95vw] sm:max-w-sm rounded-xl">
        <DialogHeader><DialogTitle>{titulo}</DialogTitle></DialogHeader>
        <div className="space-y-4 mt-1">
          <p className="text-sm text-muted-foreground">{descricao}</p>
          <input
            autoFocus
            value={nome}
            maxLength={40}
            onChange={(e) => setNome(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") criar(); }}
            placeholder={placeholder}
            className="w-full h-11 px-3 rounded-lg border-2 border-border focus:border-primary bg-background outline-none"
          />
          <div className="grid grid-cols-2 gap-2">
            <Button variant="outline" className="h-11" onClick={onFechar}>Cancelar</Button>
            <Button className="h-11 font-bold" disabled={!nome.trim() || salvando} onClick={criar}>
              {salvando ? "Gerando..." : "Gerar link"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

/** Confirmacao de exclusao de link de influencer — diz exatamente o que se perde. */
export function ModalDeletarLink({ link, onFechar, onDeletar }) {
  const [apagando, setApagando] = useState(false);
  useEffect(() => { if (link) setApagando(false); }, [link]);
  const confirmar = async () => {
    if (apagando) return;
    setApagando(true);
    try { await onDeletar(); onFechar(); }
    finally { setApagando(false); }
  };

  return (
    <Dialog open={!!link} onOpenChange={(v) => { if (!v) onFechar(); }}>
      <DialogContent className="w-[95vw] max-w-[95vw] sm:max-w-sm rounded-xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg bg-destructive text-white flex items-center justify-center">
              <AlertTriangle className="w-4 h-4" />
            </span>
            Deletar link de {link?.nome}?
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-1">
          <div className="rounded-xl bg-destructive/10 border border-destructive/30 p-3 text-sm space-y-2">
            <p className="font-semibold">Você perde, sem volta:</p>
            <ul className="space-y-1.5 text-muted-foreground">
              <li className="flex items-center gap-2">
                <MousePointerClick className="w-4 h-4 shrink-0 text-sky-500" />
                <span><strong className="text-foreground tabular-nums">{(link?.cliques || 0).toLocaleString("pt-BR")}</strong> clique{link?.cliques === 1 ? "" : "s"} registrados</span>
              </li>
              <li className="flex items-center gap-2">
                <ShoppingBag className="w-4 h-4 shrink-0 text-violet-500" />
                <span><strong className="text-foreground tabular-nums">{(link?.pedidos || 0).toLocaleString("pt-BR")}</strong> pedido{link?.pedidos === 1 ? "" : "s"} atribuídos</span>
              </li>
              <li className="flex items-center gap-2">
                <Wallet className="w-4 h-4 shrink-0 text-emerald-500" />
                <span><strong className="text-foreground tabular-nums">{reais(link?.receita_centavos || 0)}</strong> de faturamento rastreado</span>
              </li>
            </ul>
            <p className="text-xs text-muted-foreground">
              O link em si para de funcionar: quem clicar vai ver "link expirado" em vez do seu cardápio.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Button variant="outline" className="h-11" onClick={onFechar}>Cancelar</Button>
            <Button variant="destructive" className="h-11 font-bold" disabled={apagando} onClick={confirmar}>
              {apagando ? "Deletando..." : "Deletar mesmo assim"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
